var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "job-preview-content-data-outline",
    {
      staticClass: "pt25 pb25 plr20 mt15 -company",
      attrs: { "update-date": _vm.environment.updateDate },
    },
    [
      _c(
        "job-preview-right-column",
        _vm._g(
          {
            attrs: {
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "comment-class": "environment-company",
              "comment-highlights": _vm.commentHighlights,
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "data-area pt20 pb20" },
        [
          _c(
            "job-preview-content-pie-data",
            _vm._g(
              {
                attrs: {
                  "target-id":
                    "" +
                    _vm.targetIdMap.environment.woman +
                    _vm.targetIdMap.environment.company.suffix,
                  title: "女性社員の割合",
                  value: _vm.environment.womanRate,
                  "data-test": "woman",
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-preview-content-pie-data",
            _vm._g(
              {
                staticClass: "pacentage-manage",
                attrs: {
                  "target-id":
                    "" +
                    _vm.targetIdMap.environment.officer +
                    _vm.targetIdMap.environment.company.suffix,
                  title: "女性役員・管理職の割合",
                  value: _vm.environment.officerRate,
                  "data-test": "officer",
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-preview-content-bar-data",
            _vm._g(
              {
                attrs: {
                  "target-id":
                    "" +
                    _vm.targetIdMap.environment.overtime +
                    _vm.targetIdMap.environment.company.suffix,
                  title: "残業時間（平均）",
                  value: _vm.environment.overtime,
                  "average-value": _vm.average.environment.overtime,
                  unit: "時間",
                  "data-test": "overtime",
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-preview-content-bar-data",
            _vm._g(
              {
                attrs: {
                  "target-id":
                    "" +
                    _vm.targetIdMap.environment.pto +
                    _vm.targetIdMap.environment.company.suffix,
                  title: "有給取得率",
                  value: _vm.environment.ptoRate,
                  "average-value": _vm.average.environment.pto,
                  unit: "%",
                  "data-test": "pto",
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-preview-content-bar-data",
            _vm._g(
              {
                attrs: {
                  "target-id":
                    "" +
                    _vm.targetIdMap.environment.maternity +
                    _vm.targetIdMap.environment.company.suffix,
                  title: "育休取得率",
                  value: _vm.environment.maternityRate,
                  "average-value": _vm.average.environment.maternity,
                  unit: "%",
                  "data-test": "maternity",
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-preview-content-bar-data",
            _vm._g(
              {
                staticClass: "average-lengthofservice",
                attrs: {
                  "target-id":
                    "" +
                    _vm.targetIdMap.environment.lengthService +
                    _vm.targetIdMap.environment.company.suffix,
                  title: "女性社員の平均勤続年数",
                  value: _vm.environment.lengthService,
                  "average-value": _vm.average.environment.lengthService,
                  unit: "年",
                  "data-test": "lengthService",
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _vm.certificateCount
            ? _c(
                "section",
                {
                  staticClass: "data certificate mb10",
                  class: { "low-case": _vm.isCertificatePositionRight },
                  attrs: { "data-test": "certificate" },
                },
                [
                  _c(
                    "div",
                    {
                      attrs: {
                        id:
                          "" +
                          _vm.targetIdMap.environment.certification +
                          _vm.targetIdMap.environment.company.suffix,
                      },
                    },
                    [
                      _c("p", { staticClass: "h-style-02" }, [
                        _vm._v("\n          国認定\n        "),
                      ]),
                      _vm._v(" "),
                      _c("job-preview-content-data-tooltip"),
                      _vm._v(" "),
                      _c("ul", { staticClass: "mt20" }, [
                        _c(
                          "li",
                          { class: _vm.environment.isKurumin ? "on" : "" },
                          [_vm._v("\n            くるみん\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class: _vm.environment.isPlatinumKurumin
                              ? "on"
                              : "",
                          },
                          [_vm._v("\n            プラチナくるみん\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { class: _vm.environment.isNadeshiko ? "on" : "" },
                          [_vm._v("\n            なでしこ銘柄\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { class: _vm.environment.isEruboshi ? "on" : "" },
                          [_vm._v("\n            えるぼし\n          ")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.environment.womanAction
            ? _c(
                "section",
                {
                  staticClass: "data other",
                  class: [
                    { "short-case": _vm.isWomanActionPositionTop },
                    { "low-case": _vm.isWomanActionPositionRight },
                  ],
                  attrs: { "data-test": "action" },
                },
                [
                  _c(
                    "div",
                    {
                      attrs: {
                        id:
                          "" +
                          _vm.targetIdMap.environment.action +
                          _vm.targetIdMap.environment.company.suffix,
                      },
                    },
                    [
                      _c("p", { staticClass: "h-style-02" }, [
                        _vm._v("\n          その他の取り組み\n        "),
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "mt10 pega-pre-wrap",
                        domProps: {
                          textContent: _vm._s(_vm.environment.womanAction),
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }